module.exports = __webpack_public_path__ + "static/img/cats.66c08ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map/cats.png
// module id = 26JA
// module chunks = 1